<template>
  <div class="leave-board">
    <div class="box">
      <div class="title">我的留言记录</div>
      <div class="empty-img" v-if="!datas[0]">
        <img src="@/assets/index/joinParty/dp-lc1-kong.png" alt />
        <p>暂无您的留言记录~</p>
      </div>
      <div class="leave-template" v-for="(data,index) in datas" :key="index">
        <div class="people">
          <img :src="imgUrl" alt />
          <span v-text="data.name"></span>
          <span>{{data.createtime | times}}</span>
        </div>
        <div class="leave-message">
          <span>留言内容:</span>
          <span v-text="data.memo"></span>
        </div>
        <div class="report-message" v-for="msg in data.reportMsg" :key="msg.reportTimes">
          <span>回复内容:</span>
          <span v-text="msg.context"></span>
          <p v-text="msg.reportTimes"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgUrl:require("@/assets/index/joinParty/dp-lc1-icon1.png"),
      datas: [
        {
          name: sessionStorage.getItem("name"),
          leaveTimes: "",
          leaveText:"",
          // reportMsg: [
          //   {
          //     context:
          //       "习近平在参观“伟大历程 辉煌成就庆祝中华人民共和国成立70周年大型成就展",
          //     reportTimes: "2019.08.13 14:25"
          //   }
          // ]
        }
      ]
    };
  },
  name: "leaveBoard",
  methods: {
    getMsg() {
      this.axios
        .get(`/api/Index/GetUserReply?userid=${sessionStorage.getItem("id")}`)
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.datas = e.data.msg
              break;
          
            default:
              break;
          }
        });
    }
  },
  mounted() {
    this.getMsg();
  }
};
</script>
<style lang='scss' scoped>
.leave-board {
  .box {
    .empty-img {
      img {
        width: 100%;
      }
      text-align: center;
    }
    .leave-template {
      .report-message {
        border-top: 0.1rem solid #f9f9f9;
      }
      .report-message,
      .leave-message {
        p {
          text-align: right;
          color: #999999;
        }
        span {
          &:not(:nth-child(1)) {
            color: #999999;
          }
        }
        padding: 0.2rem 0;
        font-size: 0.3rem;
      }
      .people {
        span {
          &:last-child {
            margin-left: auto;
            color: #999999;
          }
          line-height: 3;
        }
        img {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 50%;
          margin-right: 0.2rem;
        }
        display: flex;
        align-items: center;
        border-bottom: 0.01rem solid #e6e6e6;
      }
      padding: 0.2rem;
    }
    .title {
      font-weight: bold;
      text-align: center;
      line-height: 3;
      font-size: 0.36rem;
    }
    width: 94%;
    margin: 0 auto;
    background: #fff;
    border-radius: 0.08rem;
    font-size: 0.3rem;
    min-height: 65vh;
  }
}
</style>